export default __webpack_public_path__ + "static/tall-maze-6d2170d45d48f127977a8892aad1d276.webp";